import { RefreshCcw, Warehouse } from 'lucide-react';
import type { CriterioCiclico, TipoInventario } from '@/hooks/inventario';
import { cn } from '@/lib/utils';

/**
 * A etiqueta discreta do tipo do inventário: "Geral", "Cíclico · por rua" ou
 * "Cíclico · por SKU". A mesma no cartão da lista e no cabeçalho do inventário.
 */
export function SeloTipo({
  tipo,
  criterio,
  className,
}: {
  tipo: TipoInventario;
  criterio: CriterioCiclico | null;
  className?: string | undefined;
}): JSX.Element {
  const ciclico = tipo === 'CICLICO';
  const Icone = ciclico ? RefreshCcw : Warehouse;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border px-1.5 py-px text-[10.5px] font-semibold',
        ciclico ? 'border-primaria/30 bg-primaria-suave text-primaria' : 'border-borda bg-superficie2 text-textoFraco',
        className,
      )}
      title={
        ciclico
          ? `Cíclico: escopos gerados ${criterio === 'SKU' ? 'pelas vagas dos SKUs escolhidos' : 'um por rua'}`
          : 'Geral: escopos montados no montador'
      }
    >
      <Icone className="h-3 w-3" aria-hidden />
      {ciclico ? `Cíclico · por ${criterio === 'SKU' ? 'SKU' : 'rua'}` : 'Geral'}
    </span>
  );
}
